/**
 * MED-921 - one invoice, one status badge.
 *
 * An invoice carries four independent booleans and they overlap: a void invoice is very often
 * also marked paid, and a written-off one can be escalated from before it was written off. So the
 * order these are tested in is the whole of the logic, and it is not arbitrary.
 *
 * Void first, then written off. Both mean "this is not money we are pursuing", and both outrank
 * `isPaid` - showing "Paid" for an invoice that was voided would misreport it as collected.
 * Escalated is a chasing state and only applies to something still outstanding, so it sorts
 * below paid.
 *
 * Extracted rather than left inline so the precedence is testable. The jsdom suites in this
 * repository cannot run, so anything worth asserting has to live outside a component.
 */
export const INVOICE_STATUS_VOID = 'Void';
export const INVOICE_STATUS_WRITTEN_OFF = 'Written Off';
export const INVOICE_STATUS_PAID = 'Paid';
export const INVOICE_STATUS_ESCALATED = 'Escalated';
export const INVOICE_STATUS_OUTSTANDING = 'Outstanding';

export const invoiceStatus = (invoice) => {
  if (!invoice) {
    return { label: INVOICE_STATUS_OUTSTANDING, className: 'badge-warning' };
  }

  if (invoice.isVoid) {
    return { label: INVOICE_STATUS_VOID, className: 'badge-secondary' };
  }

  if (invoice.isWrittenOff) {
    return { label: INVOICE_STATUS_WRITTEN_OFF, className: 'badge-secondary' };
  }

  if (invoice.isPaid) {
    return { label: INVOICE_STATUS_PAID, className: 'badge-success' };
  }

  if (invoice.isEscalated) {
    return { label: INVOICE_STATUS_ESCALATED, className: 'badge-danger' };
  }

  return { label: INVOICE_STATUS_OUTSTANDING, className: 'badge-warning' };
};
